import React, { useState } from 'react'
import Card from 'antd/es/card/Card'
import { Button, Form, Input, message } from 'antd'
import { useSendOrderNotification } from '../../../requests/order'
import { useParams } from 'react-router-dom'
const SendCustomNOtification = () => {

  const { mutate , isLoading }  = useSendOrderNotification();
  const { id } = useParams();
  const [payload, setPayload] = useState({
    title:"",
    body:"",
  });

  function sendNotification() {
    mutate({...payload, order_id: id}, {
      onSuccess:() => {
        message.success('Notification sent')
      },
      onError:err => {
        message.error(err?.message);
      }
    })
  }

  return (
    <Card title="Send notification">
        <Form layout='vertical'>
          <Form.Item label="Title">
            <Input 
              value={payload.title} 
              onChange={e => {
                setPayload(p => ({ ...p, title: e?.target?.value }))
              }}
            />
          </Form.Item>
          <Form.Item label="Body">
            <Input.TextArea rows={4} value={payload.body} 
              onChange={e => {
                setPayload(p => ({ ...p, body: e?.target?.value }))
              }}
            />
          </Form.Item>
          <Form.Item >
            <Button loading={isLoading} onClick={sendNotification}>Send</Button>
          </Form.Item>
        </Form>
    </Card>
  )
}

export default SendCustomNOtification